/**
 * 설교 영상 목록 조회를 위한 React Query Hook
 */

import { useQuery } from '@tanstack/react-query';
import { youtubeService, YouTubeResponse, PlaylistType } from '../../features/sermon/services/youtubeService';

interface UseSermonsOptions {
  pageToken?: string;
  enabled?: boolean;
}

/**
 * 설교 영상 목록을 조회하는 Hook
 * @param playlistType - 재생목록 타입 (sunday-morning, sunday-evening 등)
 * @param options - 페이지 토큰, 활성화 여부 옵션
 */
export const useSermons = (
  playlistType: PlaylistType,
  options: UseSermonsOptions = {}
) => {
  const { pageToken = '', enabled = true } = options;

  return useQuery<YouTubeResponse>({
    queryKey: ['sermons', playlistType, pageToken],
    queryFn: async () => {
      const response = await youtubeService.getVideos(playlistType, pageToken);
      return response;
    },
    // YouTube 영상 목록은 자주 변경되므로 적절한 캐시 시간 설정
    // staleTime, gcTime은 App.tsx의 기본 설정 사용
    enabled,
  });
};
